import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { BrandService } from 'brand';
import { Product } from 'product-shared';

@Component({
  selector: 'lib-product-box-header',
  templateUrl: './product-box-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class ProductBoxHeaderComponent {
  public brand = inject(BrandService);
  public product = input.required<Product>();
  public lightMode = input(false);
  public isNavProduct = input(false);
}
